export enum AuthFlowType {
  SC_EMAIL_DEFINITION = 'sc_email_definition',
  SC_EMAIL_UPDATE = 'sc_email_update',
  SC_PHONE_DEFINITION = 'sc_phoneNumber_definition',
  SC_PHONE_UPDATE = 'sc_phoneNumber_update',
  SC_PASSWORD_DEFINITION = 'sc_password_definition',
  SC_PASSWORD_UPDATE = 'sc_password_update',
  SC_LOYALTYCARD_DEFINITION = 'sc_loyaltyCard_definition',
}

export interface FlowConfig {
  flow: AuthFlowType;
  labels: {
    headerTitle: string;
    headerSubtitle?: string;
    nextButton: {
      normal: string
      deeplink: string
    };
  }
  home?: string;
}

export const FLOW_CONFIGS: Record<AuthFlowType, FlowConfig> = {
  [AuthFlowType.SC_EMAIL_DEFINITION]: {
    flow: AuthFlowType.SC_EMAIL_DEFINITION,
    labels: {
      headerTitle: "site_credentials.actions.email.definition.success.header_title",
      headerSubtitle: "site_credentials.actions.email.definition.success.header_subtitle",
      nextButton: {
        normal: 'site_credentials.actions.email.definition.success.button_next_message.normal',
        deeplink: 'site_credentials.actions.email.definition.success.button_next_message.deeplink'
      },
    },
    home: "/site-credentials"
  },
  [AuthFlowType.SC_EMAIL_UPDATE]: {
    flow: AuthFlowType.SC_EMAIL_UPDATE,
    labels: {
      headerTitle: "site_credentials.actions.email.update.success.header_title",
      headerSubtitle: "site_credentials.actions.email.update.success.header_subtitle",
      nextButton: {
        normal: 'site_credentials.actions.email.update.success.button_next_message.normal',
        deeplink: 'site_credentials.actions.email.update.success.button_next_message.deeplink'
      }
    }
  },
  [AuthFlowType.SC_PASSWORD_UPDATE]: {
    flow: AuthFlowType.SC_PASSWORD_UPDATE,
    labels: {
      headerTitle: "site_credentials.actions.password.update.success.header_title",
      headerSubtitle: "site_credentials.actions.password.update.success.header_subtitle",
      nextButton: {
        normal: 'site_credentials.actions.password.update.success.button_next_message.normal',
        deeplink: 'site_credentials.actions.password.update.success.button_next_message.deeplink'
      }
    }
  },
  [AuthFlowType.SC_PASSWORD_DEFINITION]: {
    flow: AuthFlowType.SC_PASSWORD_DEFINITION,
    labels: {
      headerTitle: "site_credentials.actions.password.definition.success.header_title",
      headerSubtitle: "site_credentials.actions.password.definition.success.header_subtitle",
      nextButton: {
        normal: 'site_credentials.actions.password.definition.success.button_next_message.normal',
        deeplink: 'site_credentials.actions.password.definition.success.button_next_message.deeplink'
      }
    }
  },
  [AuthFlowType.SC_PHONE_DEFINITION]: {
    flow: AuthFlowType.SC_PHONE_DEFINITION,
    labels: {
      headerTitle: "site_credentials.actions.phonenumber.definition.success.header_title",
      headerSubtitle: "site_credentials.actions.phonenumber.definition.success.header_subtitle",
      nextButton: {
        normal: 'site_credentials.actions.phonenumber.definition.success.button_next_message.normal',
        deeplink: 'site_credentials.actions.phonenumber.definition.success.button_next_message.deeplink'
      }
    }
  },
  [AuthFlowType.SC_PHONE_UPDATE]: {
    flow: AuthFlowType.SC_PHONE_UPDATE,
    labels: {
      headerTitle: "site_credentials.actions.phonenumber.update.success.header_title",
      headerSubtitle: "site_credentials.actions.phonenumber.update.success.header_subtitle",
      nextButton: {
        normal: 'site_credentials.actions.phonenumber.update.success.button_next_message.normal',
        deeplink: 'site_credentials.actions.phonenumber.update.success.button_next_message.deeplink'
      }
    }
  },
  [AuthFlowType.SC_LOYALTYCARD_DEFINITION]: {
    flow: AuthFlowType.SC_LOYALTYCARD_DEFINITION,
    labels: {
      headerTitle: "site_credentials.actions.loyalty_card.definition.success.header_title",
      headerSubtitle: "site_credentials.actions.loyalty_card.definition.success.header_subtitle",
      nextButton: {
        normal: 'site_credentials.actions.loyalty_card.definition.success.button_next_message.normal',
        deeplink: 'site_credentials.actions.loyalty_card.definition.success.button_next_message.deeplink'
      }
    }
  },
};